import { CircularProgress, Grid, } from '@mui/material';
import React, { FunctionComponent, } from 'react'
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';

interface Props {
}

const Loading:FunctionComponent<Props> = () => {

  return (
    <AuthLayout footer={ false }>
      <Grid container justifyContent={'center'}>
        <CircularProgress />
      </Grid>
    </AuthLayout>
  );

}

export default Loading;
